/**
 * Order Details
 */

// React
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';



// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import {
  getInvoiceWithIdAction,
  requestToPayActions
} from '../saga/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLogs,
  makeSelectLoading,
  makeSelectError,
  makeSelectInvoicesList,
  makeSelectPayData
} from '../saga/selectors';

//UI
import {
  Typography,
  Paper,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Button,
} from '@material-ui/core';

import classes from '../style/details.module.scss';
import { numberWithCommas } from '../../../utils/helpers';

export function PayProcess(props: Props) {

  const requestToPayHandler = () => {
    props.requestToPayDispatch({
      body: { invoiceId: props.match.params.id }
    })
  }

  useEffect(() => {
    const { id } = props.match.params;
    props.invoiceDispatch({
      id,
      page: 0,
      size: 1000,
    });
  }, [props.match.params]);

  const redirectHandler = () => {
    if (props.payData?.redirectUrl) {
      return <Redirect to={props.payData.redirectUrl} />
    }
  }
  useEffect(() => {
    const { id } = props.match.params;
    redirectHandler();
    if (props.payData?.redirectUrl) {
      window.location.replace(props.payData?.redirectUrl)
    }
  }, [props.payData]);

  return (

    <div className={classes.root}>
      {/* <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
        پرداخت فاکتور
        <span data-cy="orderIdHead"> &nbsp; {props.match.params.id}</span>
      </Typography>

      <Grid
        container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px' }}
      >
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات پرداخت
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <Typography variant="h6" component="div">
                    پرداخت مبلغ
                    <span data-cy="orderIdHead"> &nbsp; {numberWithCommas(props.invoice.amount)} &nbsp;</span>
                    ریال بابت
                    <span data-cy="orderIdHead"> &nbsp; {decodeURI(props.invoice.subject)}</span>
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} spacing={2} >

              </Grid>
              <Grid item xs={5} spacing={2} >
                <Button
                  variant='contained'
                  size='large'
                  color='primary'
                  // style={{padding:'10px 30px'}}
                  fullWidth
                  onClick={requestToPayHandler}
                >
                  {'انتقال به درگاه پرداخت'}
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div >
  )

}
const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  invoice: makeSelectInvoicesList(),
  payData: makeSelectPayData(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    invoiceDispatch: (payload: Object) => dispatch(getInvoiceWithIdAction(payload)),
    requestToPayDispatch: (payload: Object) => dispatch(requestToPayActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(PayProcess);
